module.exports = __webpack_public_path__ + "static/media/ktb_logo.e3f56f87.png";